import { Form, FormItemProps, Input } from 'antd';
import React from 'react';
import { isMobile } from 'util/check';

interface IProps {
  name?: string;
  onChange?: (value: string) => void;
  help?: FormItemProps['help'];
  disabled?: boolean;
}

const LoginMobileItem: React.FC<IProps> = ({ name = 'mobile', onChange, help, disabled }) => {
  const validateStatus = help ? 'error' : undefined;

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.replace(/\s/g, '');
    onChange && onChange(e.target.value);
  };

  return (
    <Form.Item
      name={name}
      validateTrigger="onBlur"
      validateStatus={validateStatus}
      help={help || undefined}
      rules={[
        {
          validator(_, value) {
            if (!value) {
              return Promise.reject(new Error('请输入手机号'));
            } else if (!isMobile(value)) {
              return Promise.reject(new Error('手机号格式错误'));
            } else {
              return Promise.resolve();
            }
          }
        }
      ]}
      getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}
    >
      <Input disabled={disabled} maxLength={11} size="large" placeholder="请输入手机号" onChange={onInputChange} />
    </Form.Item>
  );
};

export default LoginMobileItem;
